import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { TeachersCardState } from 'features/teachers';
import { Col, Flex, Row, Typography, Section } from 'components';

import TeachersCard from '../teachersCard';

interface TeachersListProps {
  teachers: TeachersCardState[];
}

const TeachersList = ({ teachers }: TeachersListProps): ReactElement => {
  const { productSlug } = useParams();

  const sanitizedTeachers =
    productSlug === 'na-rota-do-mercado-financeiro' ? teachers.filter((teacher) => teacher.slug === 'raony-rossetti') : teachers;

  return (
    <Flex bg="gray_200" flexGrow={1}>
      <Section flexDirection="column" flexGrow={0}>
        <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0}>
          <Flex flexDirection="column" flexGrow={0}>
            {productSlug !== 'na-rota-do-mercado-financeiro' && (
              <Typography type="type3" color="dark_350" upper mb={2}>
                Equipe
              </Typography>
            )}

            <Typography type="type8" fontWeight="bold" color="dark_350">
              {productSlug === 'na-rota-do-mercado-financeiro' ? <>Conheça o seu mentor</> : <>Conheça nossos professores</>}
            </Typography>
          </Flex>
        </Flex>

        {Boolean(sanitizedTeachers.length) ? (
          <Row gutter={20} flexGrow={0}>
            {sanitizedTeachers.map((teacher, index) => (
              <Col key={index.toString()} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mt={{ m: 30 }}>
                <TeachersCard teacher={teacher} />
              </Col>
            ))}
          </Row>
        ) : (
          <Flex mt={30}>
            <Typography type="type5" color="alert_400" fontWeight="bold">
              Nenhum professor encontrado.
            </Typography>
          </Flex>
        )}
      </Section>
    </Flex>
  );
};

export default TeachersList;

// import React, { ReactElement } from 'react';

// import { ProductsModulesCard, ProductsModuleCardState } from 'features/products';
// import { Col, Flex, Row, Typography, Section } from 'components';

// interface ProductsListProps {
//   modules: ProductsModuleCardState[];
// }

// const ProductsModulesList = ({ modules }: ProductsListProps): ReactElement => {
//   return (

//   );
// };

// export default ProductsModulesList;
